import { render, staticRenderFns } from "./category-last.vue?vue&type=template&id=5b3ea77b"
import script from "./category-last.vue?vue&type=script&lang=js"
export * from "./category-last.vue?vue&type=script&lang=js"
import style0 from "./category-last.vue?vue&type=style&index=0&id=5b3ea77b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports